

import React, { useState, useEffect } from "react";
import { ClipLoader } from "react-spinners";
// import AgendaItem from "./AgendaItem";
// import CardsItem from "./CardsItem";
import { useDispatch, useSelector } from "react-redux";
import {
  vtasAnioMesNow,
  orderVentas,
  orderVentasMonthNow,
  vtasMesandAnioxParam,
  orderVentasMonthAnioXParam,
  resetVentasXanioandMesParam,
  vtasxA,
  predictionsSalesxAnio
} from "../../reducer/actions/actionsVentas";
import { informSalesSupplyByMonthNow, informSalesSupplyByMonth, resetSalesByMonth } from "../../reducer/actions/supply/actionsInformSalesSupply"
import "./InformeVentas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";

import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import back from "../../icons/back.png";
import infMonth from "../../icons/infMonth.png";
import convertArrayServxAnio from "../../functions/convertArrayServxAnio";
import { faSortAlphaDown } from "@fortawesome/free-solid-svg-icons";
import { FaChartBar } from "react-icons/fa";
import convertNum from "../../functions/convertNum";
import sumaTotalesArray from "../../functions/sumaTotalesArray";
import sumaTotalesArraySale from "../../functions/sumaTotalesArraySale";
import {
  faChartLine,
  faHandHoldingDollar,
  faCreditCardAlt,
  faBuildingColumns,
} from "@fortawesome/free-solid-svg-icons";
// import { Chart } from "primereact/chart";
import DetailsSaleSelected from "../Sale/DetailsSaleSelected";

export default function TodoList() {
  const isIndumentary = useSelector((state) => state.company.categoryIndumentary)
  const companySelectedMenu = useSelector((state) => state.company.companySelected);
  const listSalesByMonthNow = useSelector((state) => state.salesSupply.listSalesSuppliesByMonthNow.sales)
  const listSalesByMonth = useSelector((state) => state.salesSupply.listSalesSuppliesByMonth.sales)

  //devolucion decha actual
  let date = new Date();
  //console.log(date.toISOString().split('T')[0]);
  const mes = date.getMonth() + 1;
  //console.log(mes)
  const anio = date.getFullYear();
  //console.log(anio)

  const MySwal = withReactContent(Swal);
  const ventas = useSelector((state) => state.sales.vtasxAnioandMesNow);

  const ventasXAnio = useSelector((state) => state.sales.vtasxAnio);

  const numberPrediction = useSelector((state) => state.sales.dataPrediction)

  const vtasFiltered = useSelector((state) => state.sales.vtasxAnioandMesParam);


  const dispatch = useDispatch();

  const productsInv3 = useSelector((state) => state.sales.allVentas);
  // console.log(productsInv3, "listVentas");
  const [loading, setLoading] = useState(false)
  const [newTurno, setNewTurno] = useState(false);
  const [newClient, setNewClient] = useState(false);
  const [newVentas, setNewVentas] = useState(false);
  const [editClient, setEditClient] = useState(false);
  const [inputState, setInputState] = useState({
    id: "",
    name: "",
    date: "",
    valorServ: "",
  });
  const [seletedMeses, setSelectedMeses] = useState("");
  //console.log(seletedMeses)
  const [seletedAño, setSelectedAño] = useState("");
  const [sumaTotalsState, setStateSumaTotals] = useState({
    sumaMes: 0,
    sumaEfectivo: 0,
    sumaTarjeta: 0,
    sumaTransferencia: 0,
  });
  const [sumaTotalsState2, setStateSumaTotal2] = useState({
    sumaMes: 0,
    sumaEfectivo: 0,
    sumaTarjeta: 0,
    sumaTransferencia: 0,
  });

  const [sumaTotalsState3, setStateSumaTotal3] = useState({
    sumaMes: 0,
    sumaEfectivo: 0,
    sumaTarjeta: 0,
    sumaTransferencia: 0,
  });

  const [sumaTotalsSaleByMonth, setStateTotalsSaleByMonth] = useState({
    sumaMes: 0,
    sumaEfectivo: 0,
    sumaTarjeta: 0,
    sumaTransferencia: 0,
  });

  const [stateDetailsSale, setStateDetailsSale] = useState()
  const [stateListSalesByMontFiltered, setStateListSalesByMonthFiltered] = useState()


  useEffect(() => {
    if (companySelectedMenu) {
      dispatch(vtasAnioMesNow(companySelectedMenu._id));
      dispatch(informSalesSupplyByMonthNow(companySelectedMenu._id))
      dispatch(vtasxA(companySelectedMenu._id, anio));
    }
  }, [dispatch, companySelectedMenu]);

  useEffect(() => {
    if (vtasFiltered !== undefined) {
      setLoading(false)
    }
  }, [vtasFiltered]);

  useEffect(() => {
    if (listSalesByMonth !== undefined) {
      setLoading(false);
    }
  }, [listSalesByMonth]);

  useEffect(() => {
    if (ventasXAnio && ventasXAnio.length) {
      const predictionsSales = convertArrayServxAnio(ventasXAnio).meses;
      const listSales = predictionsSales.map(e => e.sumaMes);
      if (listSales.length) {
        dispatch(predictionsSalesxAnio(listSales));
      }
    }
  }, [ventasXAnio, dispatch]);

  useEffect(() => {
    if (ventas && ventas.length) {
      setStateSumaTotals(sumaTotalesArray(ventas))
    }
  }, [ventasXAnio, dispatch]);

  //suma totales ventas (servicios) por mes seleccionado
  useEffect(() => {
    if (vtasFiltered && vtasFiltered.length) {
      setStateSumaTotal2(sumaTotalesArray(vtasFiltered));
    }
  }, [vtasFiltered, dispatch]);

  //suma totales ventas de insumos por mes actual
  useEffect(() => {
    if (listSalesByMonthNow && listSalesByMonthNow.length) {
      setStateSumaTotal3(sumaTotalesArraySale(listSalesByMonthNow));
    }
  }, [listSalesByMonthNow, dispatch]);


  //suma totales ventas de insumos por mes seleccionado
  useEffect(() => {
    if (listSalesByMonth && listSalesByMonth.length) {
      setStateTotalsSaleByMonth(sumaTotalesArraySale(listSalesByMonth));
    }
  }, [listSalesByMonth, dispatch]);


  //resetamos el informe mensual cada vez que se desmmonta el componente para evitar que se muestren datos al cambiar de pagina y volver a ingresar

  useEffect(() => {
    return () => {
      dispatch(resetSalesByMonth());
      dispatch(resetVentasXanioandMesParam())
    };
  }, [dispatch]);

  function SearchVentas() {
    const date = "" + seletedAño + seletedMeses;
    setLoading(true)
    dispatch(vtasMesandAnioxParam(companySelectedMenu._id, date));
    dispatch(informSalesSupplyByMonth(companySelectedMenu._id, date));
  }

  //**************SELECTOR MESES**************************/
  let listadoMeses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const meses = [];

  listadoMeses.map(function (mes, index) {
    const optionMes = { value: index + 1, label: mes };
    meses.push(optionMes);
  });

  //console.log(meses);

  // const meses=[
  // {value: 1, label: 'enero'},
  // {value: 2, label: 'febrero'},
  // {value: 3, label: 'marzo'},
  // {value: 4, label: 'abril'},..........
  // ]

  const changeMeses = (value) => {
    setSelectedMeses(value.value);
  };

  //******************************************** */

  //**************SELECTOR AÑOS**************************/
  let listadoAños = [2022, 2023, 2024, 2025, 2026];
  const años = [];

  listadoAños.map((año) => {
    const optionAño = { value: año, label: año };
    años.push(optionAño);
  });

  //console.log(años);

  // const meses=[
  // {value: 1, label: 'enero'},
  // {value: 2, label: 'febrero'},
  // {value: 3, label: 'marzo'},
  // {value: 4, label: 'abril'},..........
  // ]

  const changeAño = (value) => {
    setSelectedAño(value.value);
  };

  //******************************************** */
  const [order, setOrder] = useState(false);
  const [order2, setOrder2] = useState(false);

  const listadoVentas = ventas;

  function handleOrder(e) {
    setOrder(!order);
    dispatch(orderVentasMonthNow(order));
  }

  function handleOrder2(e) {
    setOrder2(!order2);
    dispatch(orderVentasMonthAnioXParam(order2));
  }

  let labels = [];
  let data3 = [];

  if (productsInv3) {
    labels = productsInv3.map((e) => e.name);
    //console.log(labels, "listVentas1");
    data3 = productsInv3.map((e) => e.valorServ);
    //console.log(data3, "listVentas2");
  }

  const data = {
    labels,
    datasets: [
      {
        data: data3,
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#cacfd2",
          "#a93226",
          "#d1f2eb",
        ],
        hoverBackgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#cacfd2",
          "#a93226",
          "#d1f2eb",
        ],
      },
    ],
  };

  function convertDateFormat(date) {
    if (!date) return "";

    const onlyDate = date.split("T")[0]; // "2026-01-03"
    return onlyDate.split("-").reverse().join("/"); // "03/01/2026"
  }

  function resetVtasXParams() {
    dispatch(resetVentasXanioandMesParam())
  }

  const [openModalNoteCred, setOpenModalNoteCred] = useState(false)


  function functionOpenModal() {
    setOpenModalNoteCred(!openModalNoteCred)
  }


  function handleSale(e, props) {

    e.preventDefault();
    setStateDetailsSale({
      _id: props._id,
      efectivo: props.efectivo,
      tarjeta: props.tarjeta,
      transferencia: props.transferencia,
      items: props.items,
      numeSale: props.numeSale,
      nameSupply: props.nameSupply
    })

    setOpenModalNoteCred(false)
  }


  return (
    <div>

      {/* container buttons */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-6 col-md-4 mb-3 justify-content-center">
            <div className="text-center">
              <div className="card-body">
                <Link to="/InformeAnualVtas">
                  <button className="btn btn-link">
                    <img src={infMonth} />
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-4 mb-3 justify-content-center">
            <div className="text-center">
              <div className="card-body mt-1">
                <Link to="/">
                  <button className="btn btn-link">
                    <img src={back} onClick={resetVtasXParams} />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      {

        !isIndumentary &&
        <>

          <div className="titGral">
            <h2>Servicios del Mes Actual</h2>
          </div>

          {Array.isArray(ventas) && ventas.length > 0 ? (
            // HOVER para que semarque con el cursor
            // BODERED para que se marquen los bordes de las columnas
            <div className="container-lg table-responsive">
              <table className="table table-bordered table-hover table-white">
                <thead class="thead-light">
                  <tr className="instrument-serif-regular">
                    <th >
                      Fecha{" "}
                      <FontAwesomeIcon
                        onClick={(e) => handleOrder(e)}
                        color={order ? "#FF846A" : "#A2DFFF"}
                        icon={faSortAlphaDown}
                        size="lg"
                        style={{ cursor: "pointer" }}
                      />
                    </th>
                    <th>Valor Servicio</th>
                    {/* <th>Efectivo</th>
          <th>Banco</th>
          <th>Tarjeta</th> */}
                    <th>Cliente</th>
                  </tr>
                </thead>
                <tbody className="instrument-serif-regular">
                  {ventas.map((vta) => (
                    <tr key={vta._id}>
                      <td>{convertDateFormat(vta.date)}</td>
                      {vta.valorServ ? <td>{convertNum(vta.valorServ)}</td> : <td>{convertNum(0)}</td>}
                      {/* {vta.efectivo ? <td>{convertNum(vta.efectivo)}</td> : <td>{convertNum(0)}</td>}
            {vta.transferencia ? (
              <td>{convertNum(vta.transferencia)}</td>
            ) : (
              <td>{convertNum(0)}</td>
            )}
            {vta.tarjeta ? <td>{convertNum(vta.tarjeta)}</td> : <td>{convertNum(0)}</td>} */}
                      <td>{vta.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="containerInforme">
                <div className="cardInf">
                  <div>
                    <FontAwesomeIcon icon={faChartLine} size="lg" />
                    <p>Total Servicios: {convertNum(sumaTotalsState.sumaMes)}</p>
                  </div>
                </div>
                <div className="cardInf">
                  <div>
                    <FontAwesomeIcon icon={faHandHoldingDollar} size="lg" />
                    <p>Total Efectivo: {convertNum(sumaTotalsState.sumaEfectivo)}</p>
                  </div>
                </div>
                <div className="cardInf">
                  <div>
                    <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                    <p>Total Banco: {convertNum(sumaTotalsState.sumaTransferencia)}</p>
                  </div>
                </div>
                <div className="cardInf">
                  <div>
                    <FontAwesomeIcon icon={faCreditCardAlt} size="lg" />
                    <p>Total Tarjeta: {convertNum(sumaTotalsState.sumaTarjeta)}</p>
                  </div>
                </div>
              </div>

            </div>
          ) : (
            <div className="titGral container-lg P-2">
              <h2 className="alertSearch">No existen Servicios del Mes Actual</h2>
            </div>
          )}
        </>

      }

      {/* TABLE SSALES MONTH NOW*/}
      {Array.isArray(listSalesByMonthNow) && listSalesByMonthNow.length > 0 ? (
        <div className="container-lg table-responsive">
          <div className="titGral">
            <h2>Ventas del Mes Actual</h2>
          </div>
          <table className="table table-bordered table-hover table-white">
            <thead class="thead-light table-dark instrument-serif-regular">
              <tr>
                <th>
                  Fecha{" "}
                  {/* <FontAwesomeIcon
                    onClick={(e) => handleOrder2(e)}
                    color={order2 ? "#FF846A" : "#A2DFFF"}
                    icon={faSortAlphaDown}
                    size="lg"
                    style={{ cursor: "pointer" }}
                  /> */}
                </th>
                <th>Valor de Venta</th>
                {/* <th>Efectivo</th>
                <th>Banco</th>
                <th>Tarjeta</th> */}
                <th>Plataforma</th>
                <th>Nª Venta</th>
              </tr>
            </thead>
            <tbody className="instrument-serif-regular">
              {listSalesByMonthNow.map((sale) => (
                <tr key={sale._id}>
                  <td>{convertDateFormat(sale.date)}</td>
                  {sale.totalSale ? <td>{convertNum(sale.totalSale)}</td> : <td>{convertNum(0)}</td>}
                  {/* {sale.paymentMethodEfectivo ? <td>{convertNum(sale.paymentMethodEfectivo)}</td> : <td>{convertNum(0)}</td>}
                  {sale.paymentMethodTransferencia ? <td>{convertNum(sale.paymentMethodTransferencia)}</td> : <td>{convertNum(0)}</td>}

                  {sale.paymentMethodTarjeta ? <td>{convertNum(sale.paymentMethodTarjeta)}</td> : <td>{convertNum(0)}</td>} */}
                  {sale.platformMethod ? <td>{sale.platformMethod}</td> : <td>{"Plataforna NO Declarada"}</td>}
                  {sale.numeSale ? <td>{sale.numeSale}</td> : <td>{0}</td>}
                </tr>


              ))}
            </tbody>
          </table>
          <div className="containerInforme">
            <div className="cardInf">
              <div>
                <FontAwesomeIcon icon={faChartLine} size="lg" />
                <p>Total Vendido: {convertNum(sumaTotalsState3.sumaMes)}</p>
              </div>
            </div>
            <div className="cardInf">
              <div>
                <FontAwesomeIcon icon={faHandHoldingDollar} size="lg" />
                <p>Total Efectivo: {convertNum(sumaTotalsState3.sumaEfectivo)}</p>
              </div>
            </div>
            <div className="cardInf">
              <div>
                <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                <p>Total Banco: {convertNum(sumaTotalsState3.sumaTransferencia)}</p>
              </div>
            </div>
            <div className="cardInf">
              <div>
                <FontAwesomeIcon icon={faCreditCardAlt} size="lg" />
                <p>Total Tarjeta: {convertNum(sumaTotalsState3.sumaTarjeta)}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="titGral container-lg p-2">
          <h2 className="alertSearch">No existen Ventas del Mes Actual</h2>
        </div>
      )}

      {/* PREDICCION DE VENTAS PARA EL MES SELECCIONADO */}
      {/* <div className="containerInforme">
        <div className="cardInf">
          <div className="titGral">

            <h2>Prediccion de ventas para el mes {mes + 1} </h2>
          </div>
          <p>
            <FaChartBar /> {convertNum(numberPrediction)}
          </p>
        </div>

      </div> */}

      <div className="container-lg p-1 instrument-serif-regular">
        <Select
          className="classSelect"
          placeholder="Seleccione Año"
          options={años}
          onChange={changeAño}
        />
      </div>

      <div className="container-lg p-1 instrument-serif-regular">
        <Select
          className="classSelect"
          placeholder="Seleccione Mes"
          options={meses}
          onChange={changeMeses}
        />
      </div>


      <div className="container-lg p-2">
        <button
          className={`container-lg P-2 ${!seletedAño || !seletedMeses ? "buttonBuscDesact" : "buttonBusc"
            }`}
          onClick={() => SearchVentas()}
          disabled={!seletedAño || !seletedMeses ? true : false}
        >
          Buscar Listado
        </button>
      </div>


      {loading ? (

        <div className="d-flex vh-100 justify-content-center align-items-center flex-column">
          <ClipLoader color="#000" loading={true} size={70} />
          <div className="titGral">
            <h2 className="mt-3">Espere un Momento por favor ...</h2>
          </div>
        </div>

      ) : (

        <>
          {
             !isIndumentary && Array.isArray(vtasFiltered) && vtasFiltered.length > 0 ? (
              <div>
                <div className="container-lg table-responsive">
                  <div className="titGral">
                    <h2>Servicios del Mes Seleccionado</h2>
                  </div>
                  <table className="table table-bordered table-hover table-white">
                    <thead class="thead-light table-white instrument-serif-regular">
                      <tr>
                        <th>
                          Fecha{" "}
                          <FontAwesomeIcon
                            onClick={(e) => handleOrder2(e)}
                            color={order2 ? "#FF846A" : "#A2DFFF"}
                            icon={faSortAlphaDown}
                            size="lg"
                            style={{ cursor: "pointer" }}
                          />
                        </th>
                        <th>Valor de Servicio</th>
                        {/* <th>Efectivo</th>
                        <th>Banco</th>
                        <th>Tarjeta</th> */}
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody className="instrument-serif-regular">
                      {vtasFiltered.map((vta) => (
                        <tr key={vta._id}>
                          <td>{convertDateFormat(vta.date)}</td>
                          {vta.valorServ ? <td>{convertNum(vta.valorServ)}</td> : <td>{convertNum(0)}</td>}
                          {/* {vta.efectivo ? <td>{convertNum(vta.efectivo)}</td> : <td>{convertNum(0)}</td>}
                          {vta.transferencia ? (
                            <td>{convertNum(vta.transferencia)}</td>
                          ) : (
                            <td>{convertNum(0)}</td>
                          )}
                          {vta.tarjeta ? <td>{convertNum(vta.tarjeta)}</td> : <td>{convertNum(0)}</td>} */}
                          <td>{vta.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="containerInforme">
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faChartLine} size="lg" />
                        <p>Total Servicio: {convertNum(sumaTotalsState2.sumaMes)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faHandHoldingDollar} size="lg" />
                        <p>Total Efectivo: {convertNum(sumaTotalsState2.sumaEfectivo)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                        <p>Total Banco: {convertNum(sumaTotalsState2.sumaTransferencia)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faCreditCardAlt} size="lg" />
                        <p>Total Tarjeta: {convertNum(sumaTotalsState2.sumaTarjeta)}</p>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            ) : vtasFiltered && vtasFiltered.length === 0 ?

              (
                <div className="titGral container-lg p-2">
                  <h2 className="alertSearch">No existen Servicios para el Mes Seleccionado</h2>
                </div>
              ) : null
          }

          {
           Array.isArray(listSalesByMonth) && listSalesByMonth.length > 0 ? (
              <div>
                <div className="titGral">
                  <h2>Ventas del Mes Seleccionado</h2>
                </div>

                <div className="container-lg table-responsive">

                  <table className="table table-bordered table-hover table-white">
                    <thead class="thead-light table-dark instrument-serif-regular">
                      <tr>
                        <th>
                          Fecha{" "}
                          {/* <FontAwesomeIcon
                            onClick={(e) => handleOrder2(e)}
                            color={order2 ? "#FF846A" : "#A2DFFF"}
                            icon={faSortAlphaDown}
                            size="lg"
                            style={{ cursor: "pointer" }}
                          /> */}
                        </th>
                        <th>Valor de Venta</th>
                        <th>Plataforma</th>
                        <th>Nª Venta</th>
                      </tr>
                    </thead>
                    <tbody className="instrument-serif-regular">
                      {listSalesByMonth.map((sale) => (
                        <tr key={sale._id}>

                          {sale.date ?

                            <td className={sale.status === "partial_return" ? "text-warning" : "text-dark"} style={{ cursor: "pointer" }}
                              onClick={
                                (e) => handleSale(e, {
                                  _id: sale._id,
                                  efectivo: sale.paymentMethodEfectivo,
                                  tarjeta: sale.paymentMethodTarjeta,
                                  transferencia: sale.paymentMethodTransferencia,
                                  items: sale.items,
                                  numeSale: sale.numeSale
                                })

                              }
                            >{convertDateFormat(sale.date)}</td> : null

                          }


                          {sale.totalSale ? <td className={sale.status == "partial_return" ? "text-warning" : "text-dark"}>{convertNum(sale.totalSale)}</td> : <td>{convertNum(0)}</td>}
                          {sale.platformMethod ? <td className={sale.status == "partial_return" ? "text-warning" : "text-dark"}>{sale.platformMethod}</td> : <td>{"Plataforna NO Declarada"}</td>}
                          {sale.numeSale ? <td className={sale.status == "partial_return" ? "text-warning" : "text-dark"}>{sale.numeSale}</td> : <td>{"No existe"}</td>}
                        </tr>


                      ))}
                    </tbody>
                  </table>

                  <div className="containerInforme">
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faChartLine} size="lg" />
                        <p>Total Vendido: {convertNum(sumaTotalsSaleByMonth.sumaMes)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faHandHoldingDollar} size="lg" />
                        <p>Total Efectivo: {convertNum(sumaTotalsSaleByMonth.sumaEfectivo)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                        <p>Total Banco: {convertNum(sumaTotalsSaleByMonth.sumaTransferencia)}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faCreditCardAlt} size="lg" />
                        <p>Total Tarjeta: {convertNum(sumaTotalsSaleByMonth.sumaTarjeta)}</p>
                      </div>
                    </div>
                  </div>

                  {/* <div className="containerInforme">

                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faHandHoldingDollar} size="lg" />
                        <p>Total Efectivo: {detailsSale && detailsSale.efectivo ? convertNum(detailsSale.efectivo) : "$ 0"}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                        <p>Total Banco: {detailsSale && detailsSale.transferencia ? convertNum(detailsSale.transferencia) : "$ 0"}</p>
                      </div>
                    </div>
                    <div className="cardInf">
                      <div>
                        <FontAwesomeIcon icon={faCreditCardAlt} size="lg" />
                        <p>Total Tarjeta: {detailsSale && detailsSale.tarjeta ? convertNum(detailsSale.tarjeta) : "$ 0"}</p>
                      </div>
                    </div>


                  </div> */}
                </div>

                <DetailsSaleSelected detailsSale={stateDetailsSale} setStateDetailsSale={setStateDetailsSale} setOpenModalNoteCred={setOpenModalNoteCred} openModalNoteCred={openModalNoteCred} />


              </div>

            ) : listSalesByMonth && listSalesByMonth.length === 0 ? (
              <div className="titGral container-lg p-2">
                <h2 className="alertSearch">No existen Ventas para el Mes Seleccionado</h2>
              </div>
            ) : null
          }

        </>

      )

      }

    </div>
  )
}





